import { ReactNode, SyntheticEvent } from "react";

import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import Snackbar from "@mui/material/Snackbar";

interface ActionSnackbarProps {
  duration?: number;
  open: boolean;
  message: string;
  onClose: (event: SyntheticEvent | Event, reason?: string) => void;
  additionalAction?: ReactNode;
}

export const SNACKBAR_DURATION_DEFAULT = 4500;
export const SNACKBAR_DURATION_FOREVER = -1;

export default function ActionSnackbar({
  duration = SNACKBAR_DURATION_DEFAULT,
  open,
  message,
  onClose,
  additionalAction
}: ActionSnackbarProps) {
  const action = (
    <>
      {additionalAction}
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={onClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </>
  );

  return (
    <Snackbar
      open={open}
      autoHideDuration={duration < 0 ? null : duration}
      onClose={onClose}
      message={message}
      action={action}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      sx={{ zIndex: 15000 }}
    />
  );
}
